module.exports = __webpack_public_path__ + "mainassets/img/meshlin-double arrow-down.f4e57671.svg";